// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__siTMf","row":"style_row__d8RHN","details":"style_details__eRBUE","message":"style_message__2ITw8"};